import React from "react";
import { Box } from "@mui/material";
import { unitCode } from "../../../common/models/CommonModels";
import { Quantity } from "../../models/models";
import useTranslation from "../../hooks/useTranslation";

export interface QuantityFormatProps {
  value?: Quantity | null;
}

const QuantityFormat = ({ value }: QuantityFormatProps) => {
  const { translate } = useTranslation("common");
  return (
    <>
      <Box component="span" className="text-14-medium" color="#22242D">
        {value?.value}&nbsp;
      </Box>
      <Box component="span" className="text-12-regular" color="#747881">
        {translate(`common:measurementUnits.${unitCode(value?.unitCode)}`)}
      </Box>
    </>
  );
};

export default QuantityFormat;